import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type {
  GetZuubInsuranceListRequest,
  GetZuubInsuranceListResponse,
} from '../@types/zuub/contracts';
import { makeAPIRequestReactQueryWithHeaders } from './api';
import { endpoints } from './endpoints';

interface UseGetZuubInsuranceListParams {
  unifiedIds: string[];
  enabled?: boolean;
}

export const useGetZuubInsuranceList = ({
  unifiedIds,
  enabled = true,
}: UseGetZuubInsuranceListParams) => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery(
    [endpoints.zuubInsuranceList, unifiedIds],
    () => {
      const request: GetZuubInsuranceListRequest = {
        unifiedIds,
      };

      return makeAPIRequestReactQueryWithHeaders<GetZuubInsuranceListResponse>(
        endpoints.zuubInsuranceList,
        {},
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'POST',
        {
          data: request,
        },
      );
    },
    {
      enabled: enabled && unifiedIds.length > 0,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
};
